// Default task
export const defaultTask = {
  id: null,
  title: "",
  description: "",
  add_to_library: false,
  attachment_required: false,
  is_required: false,
  students_selected_by: null,
  tags: [],
  tag_ids: [],
  skills: [],
  skill_ids: [],
  lob_competences: [],
  lob_competence_ids: [],
  attachments: [],
  banner_image: null,
  mentor_classes: [],
  lesson_groups: [],
  student_ids: [],
  education_levels: [],
  allow_task_ratings: false,
  assessment_models: "simple",
  start_date: new Date().toISOString(),
  _start_date: null,
  _start_time: "09:00",
  invites_sent: false,
  send_invites: true,
  deadline: new Date().toISOString(),
  _deadline_date: null,
  _deadline_time: "09:00",
  allow_send_reminder_before_deadline: true,
  send_reminder_days_before_deadline: 1,
  progress: {},
  type: "task",
};

// default Template task
export const defaultTemplateTask = {
  id: null,
  title: "",
  description: "",
  template_name: "",
  attachments: [],
  banner_image: null,
  attachment_required: false,
  allow_task_ratings: false,
  assessment_models: "simple",
  tags: [],
  tag_ids: [],
  skills: [],
  skill_ids: [],
  subjects: [],
  education_levels: [],
  lob_competences: [],
  lob_competence_ids: [],
  type: "template_task",
};

// default Public task
export const defaultPublicTask = {
  id: null,
  title: "",
  description: "",
  template_name: "",
  attachments: [],
  banner_image: null,
  attachment_required: false,
  allow_task_ratings: false,
  assessment_models: "simple",
  tags: [],
  tag_ids: [],
  skills: [],
  skill_ids: [],
  subjects: [],
  education_levels: [],
  lob_competences: [],
  lob_competence_ids: [],
  sources: [],
  source_ids: [],
  type: "public_task",
};

export const DEFAULT_TASK_STUDENT = {
  task_student_id: null,
  assessment_status: null,
  status: null,
  assessments: [],
  allow_retry: null,
  submitted_at: null,
  completed_at: null,
};
